import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { EvidenceStatus } from "../../utils/enums";

const BlinkingStatusDot = ({ status }) => {
  // For processing status, show animated loader
  if (status === EvidenceStatus.PROCESSING) {
    return (
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          ml: 1,
          verticalAlign: "middle",
        }}
      >
        <CircularProgress
          size={12}
          thickness={4}
          sx={{
            color: "#FF8800",
            "& .MuiCircularProgress-circle": {
              strokeLinecap: "round",
            },
          }}
        />
      </Box>
    );
  }

  // For valid/invalid status, show colored dots with radial pulse animation
  let dotColor = "#FF8800"; // fallback orange
  let pulseColor = "255, 136, 0"; // RGB values for orange

  if (status === EvidenceStatus.VALID) {
    dotColor = "#4CAF50"; // green
    pulseColor = "76, 175, 80"; // RGB values for green
  } else if (status === EvidenceStatus.INVALID) {
    dotColor = "#f44336"; // red
    pulseColor = "244, 67, 54"; // RGB values for red
  }

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 20,
        height: 20,
        ml: 1,
        verticalAlign: "middle",
        position: "relative",
      }}
    >
      {/* Radial pulse background */}
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          background: `radial-gradient(circle, rgba(${pulseColor}, 0.6) 0%, rgba(${pulseColor}, 0.3) 40%, rgba(${pulseColor}, 0.1) 70%, rgba(${pulseColor}, 0) 100%)`,
          animation:
            status === EvidenceStatus.VALID || status === EvidenceStatus.INVALID
              ? "radialPulse 2s ease-out infinite"
              : "none",
          "@keyframes radialPulse": {
            "0%": {
              transform: "scale(0.5)",
              opacity: 1,
            },
            "50%": {
              transform: "scale(1.2)",
              opacity: 0.7,
            },
            "100%": {
              transform: "scale(1.5)",
              opacity: 0,
            },
          },
        }}
      />

      {/* Center dot */}
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: dotColor,
          position: "relative",
          zIndex: 1,
        }}
      />
    </Box>
  );
};

export default BlinkingStatusDot;